import {
  getApiMockParam,
  getCustomerType,
  getEventFilterIds,
  getOrganicSkus,
  getViewedSku,
  setAppId
} from './queryParamsHelpers';
import { isValidRequest } from './helpers';

export const getQueryParams = (requestConfig) => {
  const queryParams = {};
  const isPip = requestConfig?.pageContext?.isPip;
  const isStorePage = requestConfig?.pageContext?.isStorePage;

  queryParams.schema = requestConfig.schema;
  queryParams.appid = setAppId(requestConfig);
  const browserid = requestConfig.experienceContext.cookie?.adobeCookie?.MCMID;
  if (browserid) {
    queryParams.browserid = browserid;
  }

  // existing implementation
  const category = requestConfig?.pageContext?.data?.searchModel?.metadata?.categoryID;
  if (category) {
    queryParams.category = category;
  }

  const nValue = getEventFilterIds(requestConfig.pageContext);
  if (nValue) {
    queryParams.nValue = nValue;
  }

  if (!category && !nValue) {
    // if category doesn't exist from pagecontext
    // we need to send slugId
    if (requestConfig?.slugId) {
      queryParams.nValue = requestConfig.slugId;
    }
  }

  const organicskus = getOrganicSkus(requestConfig);
  if (organicskus) {
    queryParams.organicskus = organicskus;
  }

  const viewedsku = getViewedSku(requestConfig);
  if (viewedsku) {
    queryParams.viewedsku = viewedsku;
  }

  const customerType = getCustomerType(requestConfig);
  if (customerType) {
    queryParams.customerType = customerType;
  }

  const mock = getApiMockParam();
  if (mock) {
    queryParams.mock = mock;
  }

  const bannerType = requestConfig.bannerType;
  if (bannerType) {
    queryParams.bannerType = bannerType;
  }

  const carouselType = requestConfig.carouselType;
  if (carouselType && !isPip && !isStorePage) {
    queryParams.carouselType = carouselType;
  }

  /*
   * Note: ternary operation needs to check on carouselType
   * because standard banner has no bannerType, so we need to
   * effectively use show=banner as the default.
   */
  const show = carouselType ? 'product' : 'banner';
  if (isPip || isStorePage) {
    queryParams.event = show;
  } else {
    queryParams.show = show;
  }

  const appName = window?.experienceMetadata?.name;
  if (appName) {
    queryParams.appName = appName;
  }

  const storeid = requestConfig?.experienceContext?.useStoreId || requestConfig?.experienceContext?.store?.storeId;
  if (storeid) {
    queryParams.storeid = storeid;
  }

  const keyword = requestConfig?.pageContext?.keyword;
  if (keyword) {
    queryParams.keyword = keyword;
  }
  return queryParams;
};

export const getApiUrl = (queryParams) => {
  if (!isValidRequest(queryParams)) {
    return null;
  }
  let apiUrl = `/sponsored/v1?key=12345678912345678912345678900000&version=model2&_=${Date.now()}`;
  Object.keys(queryParams).forEach((el) => {
    apiUrl += '&' + el + '=' + queryParams[el];
  });

  return apiUrl;
};